import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestService } from 'src/app/common/services/rest/rest.service';
import { AppConfigService } from 'app-config';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class UserHttpService {
    constructor(public rest: RestService) {}

    public getUserTeamLeadPermissions(): Observable<boolean> {
        const api = AppConfigService.settings.apiServer.ptUserReportsService;
        const url = api.base + api.endpoints.isTeamLead;

        return this.rest
            .getRequest(url)
            .pipe(map((res) => (res.access_allowed === 'true' ? true : false)));
    }

    public getCAPStaffPermissions(): Observable<boolean> {
        const api = AppConfigService.settings.apiServer.ptUserReportsService;
        const url = api.base + api.endpoints.isCAPStaff;

        return this.rest
            .getRequest(url)
            .pipe(map((res) => (res.access_allowed === 'true' ? true : false)));
    }

    public getCommitteeMembersPermissions(): Observable<boolean> {
        const api = AppConfigService.settings.apiServer.ptUserReportsService;
        const url = api.base + api.endpoints.isCommitteeMembers;

        return this.rest
            .getRequest(url)
            .pipe(map((res) => (res.access_allowed === 'true' ? true : false) ));
    }

    // TO CALL API TO GET ALL USER PERMISSION.
    public getCombinedPermission(): Observable<Array<any>> {
        const url = AppConfigService.settings.apiServer.apiUrl + "/accessResources";
        return this.rest.getRequest(url).pipe(
            map((res) => (
                res
            )
        ));
    }
}
